import React from 'react';
import StatCard from '../StatCard/StatCard';
import { StatsData } from '../../useLandingPage.logic';
import './StatsSection.styles.scss';

interface StatsSectionProps {
  stats: StatsData[];
}

const StatsSection: React.FC<StatsSectionProps> = ({ stats }) => {
  return (
    <div className="stats-grid">
      {stats.map((stat, index) => (
        <div key={index} className="stat-card-wrapper">
          <StatCard value={stat.value} label={stat.label} />
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
